import * as Sentry from "@sentry/react";

import { useScopeStore } from "./scopeStore";

/**
 * The tenant from the /tenants/$tenantId route, mirrored into the scope store so the
 * tRPC client — created at module scope — can read it per request (the
 * x-loot-tenant header). The URL is the source of truth: the route's beforeLoad
 * writes here before any tenant-scoped component renders. The store only
 * remembers the last visited tenant and each tenant's environment selection.
 */
export function getRouteTenantId(): string | null {
  return useScopeStore.getState().routeTenantId;
}

/** Called from route beforeLoad, which re-runs per navigation — must be idempotent. */
export function setRouteTenant(id: string | null) {
  useScopeStore.getState().setRouteTenant(id);
  // Same value as the x-loot-tenant header, so an event names the tenant it was about.
  Sentry.setTag("tenant_id", id ?? "none");
}
